import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ConstructionIcon from "@mui/icons-material/Construction";
import { motion } from "framer-motion";

const ComingSoon = ({ open, onClose, title = "Coming Soon!", message }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: "0 24px 64px rgba(0,0,0,0.2)",
        },
      }}
    >
      <Box
        sx={{
          p: 3,
          background: "linear-gradient(135deg, #003d38 0%, #00786F 100%)",
          color: "white",
          textAlign: "center",
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "rgba(255,255,255,0.6)",
            "&:hover": {
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.1)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
        >
          <Box
            sx={{
              backgroundColor: "rgba(255,215,0,0.15)",
              borderRadius: "50%",
              padding: "16px",
              display: "inline-block",
              mb: 2,
              border: "2px solid rgba(255,215,0,0.2)",
            }}
          >
            <ConstructionIcon sx={{ fontSize: 48, color: "#FFD700" }} />
          </Box>
        </motion.div>

        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8, mt: 0.5 }}>
          We're working hard to bring you something amazing
        </Typography>
      </Box>

      {/* Content */}
      <DialogContent sx={{ p: 4, textAlign: "center" }}>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 3, lineHeight: 1.8 }}
        >
          {message ||
            "This feature is currently under development. Stay tuned for updates!"}
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 0.5,
              borderRadius: 2,
              backgroundColor: "rgba(0, 120, 111, 0.08)",
              color: "#00786F",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            🚀 In Development
          </Box>
          <Box
            sx={{
              px: 2,
              py: 0.5,
              borderRadius: 2,
              backgroundColor: "rgba(0, 120, 111, 0.08)",
              color: "#00786F",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            ⭐ Coming Soon
          </Box>
        </Box>

        <Button
          variant="contained"
          onClick={onClose}
          fullWidth
          sx={{
            mt: 3,
            backgroundColor: "#00786F",
            color: "#fff",
            fontWeight: 600,
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontSize: "1rem",
            "&:hover": {
              transform: "scale(1.02)",
            },
            transition:
              "transform 0.2s ease-in-out, background-color 0.2s ease",
          }}
        >
          Got it!
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ComingSoon;
